module.exports = __webpack_public_path__ + "img/電気回路_6_3_3.7bf625dd.png";